import styled from 'styled-components';

const StyledApp = styled.div`
	text-align: center;
	color: #fff;
	padding: 2rem;
	width: 100%;
	height: 100%;
	background: #574c94;
	overflow: auto;
	/* fallback for old browsers */
	background: -webkit-linear-gradient(to right, #1a5986, #574c94);
	/* Chrome 10-25, Safari 5.1-6 */
	background: linear-gradient(to right, #1a5986, #574c94);
	/* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

	.container {
		max-width: 700px;
		margin: 0 auto;
	}

	h1 {
		font-size: 3.5rem;
		margin-top: 5rem;
		margin-bottom: 0.5rem;
	}
	h2 {
		margin-top: 0.3rem;
		margin-bottom: 5rem;
		font-size: 1.9rem;
		font-weight: normal;
		opacity: 0.6;
		a {
			color: #fff;
		}
	}

	p.lead {
		font-size: 18px;
		margin-bottom: 10rem;
	}

	.nav {
		margin-top: 5rem;
		border-bottom: 2px solid #ccc;
		margin-bottom: 20px;
		> li {
			float: none;
			display: inline-block;
			color: #fff;
			font-size: 1.7rem;
			padding: 8px 20px;
			border-radius: 0 !important;
			border: 0 !important;
			cursor: pointer;
			&:hover {
				background: #444;
			}
			&.active {
				color: #000;
				background: #ccc;
			}
		}
	}

	#app-form.form {
		text-align: left;
		textarea {
			background: transparent;
			color: #fff;
			border: 0;
		}
		.form-group {
			position: relative;
			background: rgba(34, 34, 34, 0.5);
			margin: 6rem 0 2rem;
			padding: 3rem 2rem 2rem 2rem;
			/* border: 1px solid #333; */
			label.control-label {
				position: absolute;
				left: -10px;
				top: -16px;
				background: #fff;
				padding: 0.4rem 2rem 0.4rem 2rem;
				border-radius: 2em !important;
				color: #000;
				font-size: 1.6rem;
				&::before {
					content: attr(data-num);
					color: #999;
					border-radius: 100% !important;
					display: inline-block;
					padding: 0;
					font-size: 2.3rem;
					margin-right: 9px;
					position: absolute;
					left: 9px;
					top: -2px;
				}
				&.history {
					background: #444;
					color: #bbb;
					padding-left: 1.5rem;
					&::before {
						display: none;
					}
				}
			}
			.dropzone {
				border: 2px dashed #999;
				text-align: center;
				color: #eee;
				padding: 90px 0;
				margin: -3rem -2rem -2rem -2rem;
			}
			.btn-primary {
				background: #ffaa00;
				color: #000;
				border: 0;
				transition: background 1s linear;
				&.status-ready,
				&.status-processing {
					background: transparent;
					color: #555;
				}
			}
		}
	}

	.history {
		li {
			color: #aaa;
		}
	}

	.copyright {
		margin-top: 6rem;
		/* border-top: 1px solid #555; */
		padding: 20px 0;
		font-size: 1rem;
		color: #777;
		a {
			color: #999;
		}
	}
`;

export default StyledApp;



// WEBPACK FOOTER //
// ./src/app.styled.tsx